import { endpoints, ID } from '@rossum/api-client';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { useApiClient } from '../../../../../../../lib/apiClient';

export const useVersions = (
  props: {
    externalHookTemplateId: string;
    hookInterfaceId: ID;
  } | null
) => {
  const api = useApiClient();
  return useQuery({
    queryKey: [
      '@STORE',
      'versions',
      props?.externalHookTemplateId,
      props?.hookInterfaceId,
    ],
    queryFn: async () => {
      if (!props)
        throw Error('Versions can not be fetched without necessary props.');

      const { externalHookTemplateId: extensionId, hookInterfaceId } = props;

      return api
        .request(
          endpoints.hookInterfaces.invoke(hookInterfaceId, {
            payload: {
              name: 'get_hook_template_version',
              id: extensionId,
            },
          })
        )
        .then(res => {
          const parsed = z.array(z.string()).safeParse(res);

          if (parsed.success) return parsed.data;

          return undefined;
        });
    },
    enabled: !!props && props.externalHookTemplateId !== '',
  });
};
